import { createReducer } from 'utils/reduxUtils';
import flow from 'lodash/fp/flow';
import set from 'lodash/fp/set';
import {
  FETCH_GIFT_WITH_PURCHASE_LIST_FAILURE,
  FETCH_GIFT_WITH_PURCHASE_LIST_REQUEST,
  FETCH_GIFT_WITH_PURCHASE_LIST_SUCCESS,
} from './actionTypes';
import initialState from './initialState';

const reducerToActionTypeMap = {
  [FETCH_GIFT_WITH_PURCHASE_LIST_REQUEST]: flow(set('isLoading', true), set('error', false)),
  [FETCH_GIFT_WITH_PURCHASE_LIST_SUCCESS]: (state, { payload }) =>
    flow(set('isLoading', false), set('error', false), set('list', payload))(state),
  [FETCH_GIFT_WITH_PURCHASE_LIST_FAILURE]: flow(set('isLoading', false), set('error', true)),
};

export default createReducer(reducerToActionTypeMap, initialState);
